<template>
  <el-container class="container" v-loading="isLoading">
    <el-table stripe :data="projects" @cell-click="rowSelected">
      <el-table-column min-width="80" prop="name" label="Name" />
      <el-table-column min-width="20" prop="http_records_count" label="# records" align="right" />
    </el-table>
  </el-container>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      projects: null,
      isLoading: true,
    };
  },
  created() {
    this.isLoading = true;
    axios({ url: "/api/v1/project/", method: "GET" })
      .then(resp => {
        this.projects = resp.data.results;
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    rowSelected(item) {
      this.$router.push({
        name: "project",
        params: {
          api_key: item.api_key
        }
      });
    }
  }
};
</script>

<style scoped lang="sass">

.container
  padding: 20px

</style>


